import { render, staticRenderFns } from "./ModalRemanejamento.vue?vue&type=template&id=99d4b952"
import script from "./ModalRemanejamento.vue?vue&type=script&lang=js"
export * from "./ModalRemanejamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports